import { IFormularioRespostaControle } from "@/interfaces/IFormularioRespostaControle";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction(
  "FORMULARIO_CONTROLE_RESPOSTA/sync",
  (items: IFormularioRespostaControle[]) => ({
    payload: { items },
  })
);

const removeMunicipio = createAction(
  "FORMULARIO_CONTROLE_RESPOSTA/removeMunicipio",
  (municipioId: number) => ({
    payload: { municipioId },
  })
);

export const formularioControleRespostaActions = {
  sync,
  removeMunicipio,
};
